__turbopack_context__.v({
  "background": "R6_LZq_background",
  "price": "R6_LZq_price",
  "tileLayout": "R6_LZq_tileLayout",
  "tileWrapper": "R6_LZq_tileWrapper",
  "title": "R6_LZq_title",
  "titleWrapper": "R6_LZq_titleWrapper",
});
